<!-- Translated: yes -->
<template>
  <Modal :set-class="hasAccomodation ? 'no-padding' : ''" @close="localCloseModal" :wide="false" :width="'500px'" min-width="320px" :show-close="true">

    <div v-if="hasAccomodation">
      <div class="blocked info" v-if="passes.length">
        <b><icon name="info" :scale="1.4" />{{ $t('skipass.existing-booking-title') }}</b>
        <p>{{ $t('skipass.existing-booking-text') }}</p>
      </div>

      <LanguageSwitcher type="dropdown" v-if="!$store.state.isOnSite" :show-title="true" />

      <div class="padding center" v-if="passes.length">
        <button @click="goOn()" v-if="passes.length">{{ $t('skipass.existing-booking-continue') }} <icon name="arrow-white" :scale="1.2" /></button>

        <hr />
      </div>

      <div class="padding">
        <h1>{{ $t('general.people-count-title') }}</h1>

        <div class="blocked center">
          <b class="uppercase block">{{ $t('skipass.count-title') }}</b>
          <CounterButton ref="counterButton" class="counter-button" :inline="true" :count="peopleCount" :min="1" @changedCount="changePeople($event)" :suffix="' ' + $t('general.pieces-short')" />
        </div>
      </div>

      <div class="blocked info blue">
        <button class="small white border" @click="openPriceList()">{{ $t('skipass.see-pricelist') }}</button>
      </div>

      <div class="padding">
        <div class="blocked center">
          <button @click="startBooking()" :disabled="!validate()">{{ $t('general.cta.begin-booking') }} <icon name="arrow-white" :scale="1.4" /></button>
        </div>
      </div>

      <div class="blocked info green">
        <b><icon name="info" :scale="1.4" />{{ $t('skipass.children-free-title') }}</b>
        <p>{{ $t('skipass.children-free-text').replace('55', SITE_CONFIG.skipass.keycard_price) }}</p>
      </div>
    </div>

    <div v-if="!hasAccomodation">
      <div class="blocked info green" style="margin-bottom: 1rem;">
        <b><icon name="info" :scale="1.4" />Boende</b>
        <p>På denna sida kan du endast köpa eller ladda ditt liftkort tillsammans med ett boende.</p>
      </div>

      <div style="margin-bottom: 1rem;">
        <button @click="openPriceList()">{{ $t('skipass.see-pricelist') }} <icon name="arrow-white" :scale="1.4" /></button>
      </div>

      <div style="margin-bottom: 1rem;">
        <button @click="goToAccommodations()">Boendebokning <icon name="arrow-white" :scale="1.4" /></button>
      </div>

      <div class="blocked info green">
        <b><icon name="info" :scale="1.4" />{{ $t('skipass.children-free-title') }}</b>
        <p>{{ $t('skipass.children-free-text').replace('55', SITE_CONFIG.skipass.keycard_price) }}</p>
      </div>
    </div>

  </Modal>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import Modal from '@/components/components/Modal';
import CounterButton from '@/components/components/CounterButton';
import Dropdown from '@/components/components/Dropdown';
import AccomodationCartItem from '@/classes/AccomodationCartItem';
import AccomodationPeriodConfirm from '@/components/parts/Accomodation/AccomodationPeriodConfirm';

import LanguageSwitcher from '@/components/components/LanguageSwitcher';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    CounterButton,
    Dropdown,
    AccomodationPeriodConfirm,
    LanguageSwitcher,
  },
  data() {
    return {
      peopleCount: 1,
      accomodation: {},
      unit: {},
      arrival: '',
      departure: '',
      hasAccomodation: false,
    };
  },
  mounted() {
    const accomodations = JSON.parse(JSON.stringify(this.$store.state.cart.accomodations));
    const confirmed = accomodations.filter(accomodation => accomodation.confirmed);

    if (confirmed.length) {
      // Set people count
      this.peopleCount = AccomodationCartItem.peopleCount(confirmed[0]);
      this.hasAccomodation = true;

      if (this.$refs.counterButton) {
        this.$refs.counterButton.count = this.peopleCount;
      }
    } else if (this.$store.state.cart.addToOrder
      && this.$store.state.cart.addToOrder.hasAccommodation) {
      this.hasAccomodation = true;

      if (this.$refs.counterButton) {
        this.$refs.counterButton.count = this.peopleCount;
      }
    } else {
      this.hasAccomodation = false;
    }

    const completedPasses = this.$store.state
      .cart.skipasses.filter(skipass => skipass.guideCompleted);

    if (completedPasses.length) {
      this.closeModal();
      this.$router.push({ name: 'ski pass overview', query: this.$route.query });
    }
  },
  computed: {
    ...mapGetters([
      'guidedPasses',
    ]),
    passes() {
      return this.guidedPasses.filter(a => a.type === '');
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
      'addSkiPassPeople',
      'confirmedAccomodations',
    ]),
    localCloseModal() {
      if (!this.$store.state.isOnSite) {
        this.closeModal();
      }
    },
    validate() {
      let errors = 0;
      errors += (this.peopleCount ? 0 : 1);
      return !errors;
    },
    changePeople(payload) {
      // return payload;
      this.peopleCount = payload;
      // this.pickAccomodation(payload);
      // this.closeAllModals();
      // this.$router.push({ name: 'confirm-accomodation' });
    },
    startBooking() {
      this.addSkiPassPeople({
        peopleCount: this.peopleCount,
        numberOfDays: 0,
        append: false,
      });

      this.closeAllModals();

      this.$router.push({ name: 'ski pass person', query: this.$route.query, params: { person: '0' } });
    },
    goOn() {
      this.closeModal();
      this.$router.push({ name: 'ski pass overview', query: this.$route.query });
    },
    openPriceList() {
      this.openModal(['SkipassPrices']);
    },
    goToAccommodations() {
      this.closeAllModals();
      this.$router.push({ name: 'accomodation list' });
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

h1.accomodation-title
  font-size 19px
  font-weight bold
  text-align center
  color #262626
  text-transform none
  border-radius 2px
  background-color #ecf5f8
  border solid 1px #bfd9e1
  padding 7px 20px
  display inline-block

.blocked
  margin-bottom space-2
  max-width:100%;
  margin-left: auto;
  margin-right: auto;

.uppercase
  font-size: 11px
  margin-bottom: 5px

.info
  border-radius 0px
  background-color rgba(199, 220, 183, 0.26)
  border solid 1px #d1e0c2
  padding 15px 27px
  width 100%
  &.blue
    background-color: #ecf5f8;
    border 0
    text-align: center
  &.green
    margin-bottom: 0
  b
    font-size 11px
    font-weight bold
    color #1c1c1c
    display block
    margin-bottom 0.9em
    uppercase()
    .icon
      margin-right 0.7em
  p
    font-size 14px
    font-weight 300
    line-height 1.3
    color #262626
    margin 0
  &.small
    padding 10px 8px
    p
      font-size 11px
      color #1c1c1c

.padding
  padding 0 27px
h1
  margin-top 20px

select
  height 45px
  border-radius 4px
  background-color #ffffff
  border solid 2px #bfd9e1
  width 100%

hr
  border-top solid 2px #bfd9e1
  margin-top space-3

.language-switcher
  margin-top 25px
</style>



// WEBPACK FOOTER //
// SkiPassPickDate.vue?588e42c4